/**
 * Portal do cliente do CRM Lukos.
 *
 * `POST /api/portal/treinamentos` é a única rota do CRM sem sessão — de
 * propósito só de escrita (aceita o pedido, não devolve dado nenhum) e limitada
 * a 5 pedidos / 10 min por IP. O pedido entra como "pedido" e vira agendamento
 * (com o link do GoTo Meeting) quando o suporte confirma do lado de dentro do
 * CRM — este formulário nunca fala com o GoTo diretamente.
 */

const CRM_API_URL = (import.meta.env.VITE_CRM_API_URL || 'http://localhost:3336').replace(/\/$/, '');

export interface SolicitacaoTreinamento {
  cliente: string;
  tema?: string;
  dia?: string; // YYYY-MM-DD
  hora?: string; // HH:MM
  duracaoMin?: number;
  modalidade?: 'remoto' | 'presencial';
  contato?: string;
  observacao?: string;
}

export type SolicitarTreinamentoResultado =
  | { ok: true }
  | { ok: false; motivo: 'validacao' | 'limite' | 'rede'; mensagem: string };

export async function solicitarTreinamento(
  dados: SolicitacaoTreinamento
): Promise<SolicitarTreinamentoResultado> {
  try {
    const response = await fetch(`${CRM_API_URL}/api/portal/treinamentos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dados),
    });

    if (response.status === 201) return { ok: true };

    if (response.status === 429) {
      return {
        ok: false,
        motivo: 'limite',
        mensagem: 'Muitos pedidos em pouco tempo. Aguarde alguns minutos e tente de novo.',
      };
    }

    const corpo = await response.json().catch(() => null);
    return {
      ok: false,
      motivo: 'validacao',
      mensagem: corpo?.error || 'Informe ao menos o nome do cliente.',
    };
  } catch {
    return {
      ok: false,
      motivo: 'rede',
      mensagem: 'Não conseguimos enviar automaticamente agora.',
    };
  }
}
